export const CURRENT_SITE_URI = window.profile.currentSiteUri;
export const SITE_ONE_SERVICE_URI = window.profile.siteOneServiceUri;
export const REDIRECT_URL_INVITE = `${CURRENT_SITE_URI}/account/active-user`;
export const REDIRECT_URL_EMAIL_CONFIRM = `${CURRENT_SITE_URI}/account/confirm-email`;
export const REDIRECT_RESET_PASSWORD = `${CURRENT_SITE_URI}/account/reset-password`;
export const REDIRECT_INVITE_BUILDER = `${CURRENT_SITE_URI}/client/term-of-service`;
export const REDIRECT_INVITE_SUBCONTRACTOR = '/account/active-user';
export const ACCESS_TOKEN_SCHEME = window.profile.accessTokenScheme;
export const GLOBAL_API_URL = window.profile.globalApiUrl;
export const REGION_AND_MARKET = window.profile.regionAndMarket;
export const COMPANY_NAME = window.profile.clientName;
export const ROLES = window.profile.roles;
export const CLIENT_ID = window.profile.clientId;

export const USER_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
  LOCKED: 3
};

export const CLIENT_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  SUSPENDED: 2
};

export const CLIENT_TYPE = {
  System: 0,
  Builder: 1,
  Subcontractor: 2,
  HomeOwner: 3
};

export const LOCKED_TYPE = {
  RESET_PASSWORD: 0,
  CHANGE_EMAIL: 1
};

export const RegionAndMarket = {
  NONE: 0,
  REGION: 1,
  REGION_AND_MARKET: 2
};

export const LIST_ROLES = [
  { key: 'SubcontractorSuperAdmin', value: 'Subcontractor Super Admin' },
  { key: 'SubContractorUser', value: 'Subcontractor User' },
  { key: 'SubcontractorAdmin', value: 'Subcontractor Admin' },
  { key: 'SystemAdministrator', value: 'Administrator' },
  { key: 'SystemPowerUser', value: 'Power user' },
  { key: 'SystemAgent', value: 'Agent' },
  { key: 'BuilderSuperAdmin', value: 'Super admin' },
  { key: 'BuilderAdmin', value: 'Admin' },
  { key: 'BuilderUser', value: 'User' }
];

/*export const ROLES = [
  { key: 'BuilderSuperAdmin', value: 'Builder Super Admin' },
  { key: 'BuiderAdmin', value: 'Buider Admin' },
  { key: 'BuilderUser', value: 'Builder User' }
  /*{ key: 'BuilderSuperAdmin', value: 'Super admin' },
  { key: 'BuiderAdmin', value: 'Administrator' },
  { key: 'BuilderUser', value: 'User' }*/
//];

export const USER_STATUS_VALUE = [
  { key: 0, value: 'Invited' },
  { key: 1, value: 'Active' },
  { key: 2, value: 'Suspended' },
  { key: 3, value: 'Locked' }
];

export const CLIENT_STATUS_VALUE = [
  { key: 0, value: 'Invited' },
  { key: 1, value: 'Active' },
  { key: 2, value: 'Suspended' }
];

export const CLIENT_TYPE_VALUE = [
  { key: 0, value: 'System' },
  { key: 1, value: 'Builder' },
  { key: 2, value: 'Subcontractor' },
  { key: 3, value: 'Homeowner' }
];

export const RFS_STATUS = {
  AwaitingReview: 0,
  Approved: 1,
  Declined: 2,
  Closed: 3,
  Reopened: 4
};

export const RFS_STATUS_VALUE = [
  { key: 0, value: 'New' },
  { key: 1, value: 'Open' },
  { key: 2, value: 'Declined' },
  { key: 3, value: 'Closed' },
  { key: 4, value: 'Schedule' }
];

export const WO_STATUS_VALUE = [
  { key: 0, value: 'Awaiting review' },
  { key: 1, value: 'Open' },
  { key: 2, value: 'Pending' },
  { key: 3, value: 'Declined' },
  { key: 4, value: 'Resolved' },
  { key: 5, value: 'Closed' },
  { key: 6, value: 'Requested to reopen' }
];

export const PUNCH_ITEM_STATUS_VALUE = [
  { key: 1, value: 'Open' },
  { key: 2, value: 'Pending' },
  { key: 4, value: 'Resolved' },
  { key: 5, value: 'Closed' },
  { key: 6, value: 'Requested to reopen' }
];

export const DISPLAY_NAME = window.profile.DisplayName;
export const CURRENT_USER_ID = window.profile.CurrentUserId;
export const DEFAULT_ROLES = 'BuilderSuperAdmin';
export const DEFAULT_ROLES_SYSTEM = 'SystemAdministrator';
export const DEFAULT_AVATAR = window.profile.DefaultAvatar
  ? window.profile.DefaultAvatar
  : '/images/default_avatar.svg';
export const LOGO_30 = window.profile.logoUrl
  ? `${window.profile.logoUrl}`
  : null;
export const HO_LOGO = window.profile.hoLogoUrl
  ? `${window.profile.hoLogoUrl}`
  : null;  
export const NO_PICTURE = '/images/no-picture.png';
export const S1_TOKEN = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_token`
  : 's1_token';
export const S1_UID = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_uid`
  : 's1_uid';
export const S1_REFRESH_TOKEN = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_refresh_token`
  : 's1_refresh_token';
export const S1_EXPIRES_TIME = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_expires`
  : 's1_expires';
export const S1_TOKEN_CREATED = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_token_created`
  : 's1_token_created';
export const S1_ROLE_NAME = window.profile.clientName
  ? `${window.profile.clientName.replace(' ', '_')}_role_name`
  : 's1_role_name';
export const TIMEZONE = window.profile.timeZone
  ? window.profile.timeZone.moment
  : 'US/Pacific'; //'US/Pacific';

export const S1_REDIRECT_CLIENT_URL = "S1_REDIRECT_CLIENT_URL";
export const IS_SSO_USER = 'IS_SSO_USER';
export const S1_REDIRECT_CLIENT_LOGIN_URL = "S1_REDIRECT_CLIENT_LOGIN_URL";



// WEBPACK FOOTER //
// ./src/config/variables.subcontractor.js